import { useMutation } from '@tanstack/react-query';

const ejectParticipantsByRoomId = async (roomId: string) => {
  const result = await fetch(`/api/berrystreet/eject/${roomId}`).then(
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (response: any) => {
      if (!response.ok) {
        // soft fail.
        console.error(response);
      }
      return response.json();
    },
  );

  return result;
};

export const useEjectParticipants = () =>
  useMutation({
    mutationKey: ['berrystreetEjectParticipantsByRoomId'],
    mutationFn: (roomId: string) => ejectParticipantsByRoomId(roomId),
  });
